import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownInactive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 11,
	viewBox: "0 0 21 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 6.68231L18.667 0L21 1.90885L10.5 10.5L0 1.90885L2.33297 0L10.5 6.68231Z",
		fill: "#BDBDBD"
	})
});
export default SvgDownInactive;
